import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { InputBase } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useRouter } from "@miview/hooks";

const useSearchBarStyles = makeStyles()((theme) => {
  return {
    search: {
      position: "relative",
      borderRadius: 4,
      backgroundColor: "#F5F5F5",
      marginRight: theme.spacing(2),
      marginLeft: 16,
      maxWidth: 700,
      width: "100%",
    },
    searchIcon: {
      padding: `${theme.spacing(0, 3)}rem`,
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "black",
    },
    inputRoot: {
      color: "inherit",
      width: "calc(100% - 5px)",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1rem + ${theme.spacing(8)}rem)`,
      color: "black",
      fontSize: 14,
    },
  };
});

export const SearchBar = () => {
  const { classes } = useSearchBarStyles();
  const { push } = useRouter();
  const [searchText, setSearchText] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const trimmedSearchText = searchText.trim();

    if (trimmedSearchText.length) {
      push({
        pathname: "/search",
        search: `q=${searchText}`,
      });
    }

    if (trimmedSearchText !== searchText) {
      setSearchText(trimmedSearchText);
    }
  };

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon style={{ fontSize: 15 }} />
      </div>
      <form onSubmit={submit}>
        <InputBase
          placeholder="Search"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          onChange={(e) => setSearchText(e.target.value)}
          inputProps={{ "aria-label": "search" }}
          value={searchText}
        />
      </form>
    </div>
  );
};
